import { List, type ListProps, When } from "shared/react";
import { type CreatorEntity, type LeaderboardData, formatTaskAmount } from "shared/schema";
import { ProfileName } from "../entity/EntityName.js";
import { useItem, useQuery } from "../util/db.js";

/** One-sentence summary of a leaderboard entry, e.g. `2d: @dhoulb added 12 km progress` */
export function RawLeaderboardSentence({ updated, uid, type, units, amount, total }: LeaderboardData): React.ReactElement {
	return (
		<span>
			<When target={updated} />: <ProfileName uid={uid} />
			<span className="weight-normal">
				{
					!total
						? " joined the leaderboard" //
						: type === "checkbox"
						? " completed a task"
						: type === "counter"
						? " made progress on a task"
						: ` added ${formatTaskAmount(amount, type, units)} to a task` //
				}
			</span>
		</span>
	);
}

export function LeaderboardSentence({ id }: { id: string }): React.ReactElement {
	const update = useItem("leaderboard", id).data;
	return <RawLeaderboardSentence {...update} />;
}

export function LeaderboardSentences({ creator, cid, ...props }: { creator: CreatorEntity; cid: string } & ListProps): React.ReactElement {
	return (
		<List //
			store={useQuery("leaderboard", { creator, cid, $order: "!updated", $limit: 5 })}
			mapper={data => (
				<p key={data.id}>
					<RawLeaderboardSentence key={data.id} {...data} />
				</p>
			)}
			more="Show more updates"
			empty="No leaderboard activity"
			{...props}
		/>
	);
}
